import React from 'react'
import {action, observable, computed} from 'mobx'
import {Product} from '@/types/BuyTypes'
import {getProducts, getPrices, buyDevice} from '@/services/Buy'
import PayTypes from '@/types/PayType'
import {PricesType} from '@/types/NewMachineTypes'
import {message, Modal, Icon} from "antd";
import stores from '@/stores'
import report from '@/utils/log'
import * as R from 'ramda';
import {getGroupList} from "@/services/Home";
import BaseStore from "@/stores/base";

class BuyStore {
  @observable products: (Product)[] = [] // 产品列表
  @observable groupId: number // 选择的组id
  @observable payType: PayTypes = 1 // 支付方式
  @observable totalNum: number | undefined = 1 // 购买数量
  @observable prices: PricesType[] = [] // 价格列表
  @observable priceId: number | string = ''  // 选择的价格id
  @observable price: number = 0 // 当前选中的价格

  @observable loadding: boolean = false // 页面加载中

  @computed get totalPrice(): string {
    return this.totalNum ? (this.price * this.totalNum / 100).toFixed(2) : '0.00'
  }

  // 进入页面
  @action.bound
  async init() {
    await this.getProducts()
    await this.getPrices()
  }

  // 清空价格数据
  @action.bound
  async initInputData() {
    this.prices = []
    this.priceId = ''
    this.price = 0
  }

  // 获取价格产品列表
  @action.bound
  async getProducts() {
    const params = {
      roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id
    }
    const [error, result] = await getProducts(params)
    if (error) {
      // 套餐列表获取失败 事件上报
      report({
        eventId: 'E1403',
        pageId: 'P14',
        ext: '',
      })
      return;
    }
    this.products = result.product_list
    this.groupId = this.products && this.products[0].id;

    // 套餐列表获取成功 事件上报
    report({
      eventId: 'E1401',
      pageId: 'P14',
      ext: '',
    })

  }

// 修改产品类型
  @action.bound
  async changeGroupId(id: number) {
    if (this.groupId === id) return;
    // 清空价格数据
    this.initInputData()

    this.groupId = id
    this.getPrices()
  }

  // 修改支付方式
  @action.bound
  async togglePayType(id: PayTypes) {
    this.payType = id
  }

  // 购买数量
  @action.bound
  async getBuyNum(num: number | undefined) {
    this.totalNum = num
  }

  // 获取设备价格点列表
  @action.bound
  async getPrices() {
    let params = {
      product_id: this.groupId,
      scenes: 1
    }
    const [error, result] = await getPrices(params)
    if (error) return;
    this.prices = result.price_list
  }

  //修改价格
  @action.bound
  async changePrice(id: number, option: any) {
    this.priceId = id
    this.price = this.prices[option.key].real_price
  }

  // 点击购买
  @action.bound
  async deviceBuy() {
    console.log('deviceBuy')
    if (!this.priceId && this.priceId !== 0) {
      message.error('请选择套餐')
      return
    }
    if (!this.totalNum) {
      message.error('请选择购买数量')
      return
    }
    // 处理默认分组groupId
    let defaultGroup
    let getGroupListParams = {roomId: BaseStore.RoomStore.activeRoom.id}
    const [getGroupListError, getGroupListResult] = await getGroupList(getGroupListParams);
    if (!getGroupListError) {
      defaultGroup = (R.find(R.propEq('isDefault', 1))(getGroupListResult.groupList))
    }
    let params

    if (defaultGroup) {
      params = {
        roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
        groupId: defaultGroup.id,
        priceId: this.priceId,
        payType: this.payType,
        priceType: 1,
        clientType: 1,
        totalNum: this.totalNum,
        returnUrl: window.location.origin + '/home/CloudPhone',
      }
    } else {
      params = {
        roomId: JSON.parse(localStorage.getItem('activeRoom') as string).id,
        priceId: this.priceId,
        payType: this.payType,
        priceType: 1,
        clientType: 1,
        totalNum: this.totalNum,
        returnUrl: window.location.origin + '/home/CloudPhone',
      }
    }

    this.loadding = true
    const [error, result] = await buyDevice(params)
    this.loadding = false
    if (error) {
      // 支付url获取失败 事件上报
      report({
        eventId: 'E1404',
        pageId: 'P14',
        ext: '',
      })
      return;
    }

    Modal.confirm({
      content: '支付订单已提交',
      cancelText: '已完成支付',
      okText: '支付遇到问题',
      icon: <Icon type='check-circle' style={{color: '#5AD36F'}}/>,
      onCancel() {
        stores.routingStore.history.push('/Home/Order')
      },
      onOk() {
        stores.routingStore.history.push('/Home/Order')
      }
    })
    // 支付url获取成功 事件上报
    report({
      eventId: 'E1402',
      pageId: 'P14',
      ext: '',
    })
    // 支付宝支付
    if (params.payType === 1) {
      window.open(result.request_url)
      return;
    }
    // 微信支付
    window.open(`/WeixinPay/${this.totalPrice}/${result.order_id}/${encodeURIComponent(result.request_url)}`)
  }
}

export default BuyStore
